const List = () => import('./main.vue');
const Search = () => import('./search.vue');

export default [
  {
    name: 'portes-honorarios',
    path: '/portes-honorarios',
    components: { default: List, search: Search },
    meta: {
      requiresAuth: true,
      breadcrum: 'Porte Honorário',
      icon: 'tasks',
      can: 'list',
      on: 'portehonorario',
    },
  },
];
